export default __webpack_public_path__ + "static/media/typing.a2bb842b.webp";